define('lq/events/actions/googleGeocodingQuery',[
    'underscore',
    'lq/events/actions/eventAction'
], function (_, EventAction) {
    'use strict';

    function GoogleGeocodingQuery(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;

        return this;
    }

    EventAction.extend(GoogleGeocodingQuery, EventAction);

    GoogleGeocodingQuery.typeName = 'GoogleGeocodingQuery';

    GoogleGeocodingQuery.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };


    GoogleGeocodingQuery.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'GoogleGeocodingQuery',
            command: this.eventData.command
        };
    };

    GoogleGeocodingQuery.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.success) {
            if (this.eventIsEnabled('succeeded')) {
                this.triggerEvent('succeeded', continuation);
            } else {
                continuation();
            }
        } else {
            if (this.eventIsEnabled('failed')) {
                this.triggerEvent('failed', continuation);
            } else {
                alert('The geocoding of the address has been failed, and the \'failed\' event is not enabled.')
                continuation();
            }
        }
    };

    return GoogleGeocodingQuery;
});
